<template>
  <div>
    <div class="title-bar title-h3">
      {{ title }} 에이전트 설정
    </div>
    <el-row class="title-bar" type="flex" justify="end">
      <div class="vertical-center-box">
        <el-button type="primary" :disabled="!checkFlag" class="mr-r4" @click="saveAgentInfoSetting">저장</el-button>
        <el-button class="mr-r4" :disabled="!checkFlag" @click="loadAgentSettingList">취소</el-button>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" :data="agentDataList" row-class-name="c-dblclick" :editable="true" :columns="agentColumns" :pagination="false" :column-default="columnDefault"
      :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="openAgentPopup">
      <template slot-scope="scope" slot="include-switch-slot">
        <el-switch v-model="scope.row.includeConfig" :active-value="true" :inactive-value="false" @change="changeIncludeConfig(scope.row)" />
      </template>
      <template slot-scope="scope" slot="enable-switch-slot">
        <el-switch v-model="scope.row.enableConfig" :disabled="!scope.row.includeConfig" :active-value="true" :inactive-value="false" @change="checkChangeData(scope.row)" />
      </template>
    </el-table-wrapper>
    <w-update-agent-popup ref="agentPopup" :instanceId="instanceId" :agentList="agentDataList" @load="loadAgentSettingList" />
  </div>
</template>

<script>
import { cloneDeep, isEmpty, isEqual, find } from 'lodash';
import { columnDefault } from '@/constants/table';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';
import WUpdateAgentPopup from '../components/popup/UpdateAgentPopup';

export default {
  name: 'WAgentSettingView',
  components: { WUpdateAgentPopup },
  props: {
    currentNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columnDefault,
      instanceSelection: [],
      isSaveFlag: false,
      isLoading: false,
      showSearchTool: false,
      agentDataList: [],
      originalAgentDataList: [],
      checkFlag: false,
      instanceId: null,
      agentColumns: [
        {
          prop: 'includeConfig',
          label: '적용',
          editable: true,
          scopedSlot: 'include-switch-slot',
          width: 70,
          sortable: true,
        },
        {
          prop: 'enableConfig',
          label: '활성화',
          editable: true,
          scopedSlot: 'enable-switch-slot',
          width: 70,
          sortable: true,
        },
        {
          prop: 'configType',
          label: '설정유형',
          width: 80,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'configId',
          label: '설정ID',
          width: 300,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'configDesc',
          searchable: true,
          label: '설정내용',
          width: 400,
          sortable: true,
        },
        {
          prop: 'settingValue',
          label: '설정 값',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'defaultValue',
          label: '기본값',
          sortable: true,
        },
        {
          prop: 'agentRestartFlag',
          width: 130,
          label: '재시작 필요 여부',
          sortable: true,
          filters: [
            {
              text: 'Y',
              value: 'Y',
            },
            {
              text: 'N',
              value: 'N',
            },
          ],
        },
      ],
    };
  },
  computed: {
    title() {
      return `[${this.currentNode.label}]`;
    },
  },
  watch: {
    currentNode: {
      immediate: true,
      handler(currentNode) {
        if (isEmpty(currentNode) || currentNode.type !== 'obj') {
          return;
        }

        this.instanceId = currentNode.instanceId;
        this.$nextTick(() => {
          this.loadAgentSettingList();
        });
      },
    },
  },
  methods: {
    /**
     * [loadAgentSettingList 관리 설정 트리에서 인스턴스를 선택하는 경우 에이전트 설정 리스트를 조회한다.]
     * @author yelim
     */
    loadAgentSettingList() {
      this.isLoading = true;
      ApmSettingAPI.getConfigureWas({ instanceId: this.currentNode.instanceId }).then((response) => {
        this.isLoading = false;
        this.checkFlag = false;
        if (response.data.success) {
          const data = response.data.data;
          this.agentDataList = data;
          this.originalAgentDataList = cloneDeep(data);
        }
      });
    },
    /**
     * [saveAgentInfoSetting 수정한 에이전트 설정을 저장한다.]
     * 저장시 모든 에이전트의 정보를 파라메터 넘겨야한다.
     * @author yelim
     */
    saveAgentInfoSetting() {
      const params = {
        instanceId: this.currentNode.instanceId,
        children: this.agentDataList,
      };
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.MODIFY)).then(() => {
        ApmSettingAPI.setConfigureWas(params).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadAgentSettingList();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '에이전트 설정', result.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '에이전트 설정', false));
        });
      }).catch();
    },
    /**
     * 데이터 변경 감지
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    checkChangeData(record) {
      if (record.includeConfig && record.enableConfig && isEmpty(record.settingValue)) {
        record.settingValue = record.defaultValue;
      }
      this.checkFlag = !isEqual(this.agentDataList, this.originalAgentDataList);
    },
    /**
     * 적용/활성화 flag 같게 설정.
     * @param  {[type]} record [description]
     * @return {[type]}       [description]
     * @author jda
     */
    changeIncludeConfig(record) {
      if (!record.includeConfig) {
        record.enableConfig = record.includeConfig;
      }
      this.checkChangeData(record);
    },
    /**
     * 에이전트 수정 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    openAgentPopup(record) {
      const originalRecord = find(this.originalAgentDataList, { configId: record.configId });
      this.$refs.agentPopup.open(originalRecord);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/instance/AgentSettingView.vue